import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { Dialog } from 'primereact/dialog';

import { useToastNotification } from '@/hooks';
import { Button } from '@/components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { deleteLiquidacionProforma } from './services/deleteLiquidacionProforma';

type ModalDeletedProps = {
  oidVisita: number;
  visible: boolean;
  onClose: (visible: boolean) => void;
};

const ModalDeleted: FC<ModalDeletedProps> = ({
  oidVisita,
  visible,
  onClose,
}) => {
  const { t } = useTranslation('importFCL');
  const { showToast } = useToastNotification();

  const { mutate: deleteSettlement, isPending } = useMutation({
    mutationFn: deleteLiquidacionProforma,
    onSuccess: () => {
      onClose(true);
    },
    onError: (error) =>
      showToast({
        severity: 'error',
        detail: error?.message,
      }),
  });

  const toggleDialog = () => {
    onClose(false);
  };

  const dialogHeader = (
    <div>
      <FontAwesomeIcon icon={faTrash} style={{ marginRight: '0.5rem' }} />
      {t('removeContainer')}
    </div>
  );

  const onDeleteButtonClick = () => {
    deleteSettlement({ oidVisita });
  };

  const footerContent = (
    <div className="w-full flex justify-content-end ">
      <Button
        label={t('cancel')}
        link
        onClick={toggleDialog}
        disabled={isPending}
        style={{ color: '#170a33', width: '100px' }}
      />
      <Button
        style={{ backgroundColor: '#FF0000', color: '#FFFFFF', width: '100px' }}
        label={t('delete')}
        onClick={onDeleteButtonClick}
        loading={isPending}
      />
    </div>
  );

  return (
    <Dialog
      header={dialogHeader}
      visible={visible}
      breakpoints={{ '1200px': '95vw' }}
      onHide={toggleDialog}
      footer={footerContent}
    >
      <div className="px-6 pb-6">
        <p>{t('deleteContainerSettlement')}</p>
      </div>
    </Dialog>
  );
};

export default ModalDeleted;
